import React, { useContext, useEffect, useState } from "react";
import cx from "classnames";

import global from "../../../scss/dhp.scss";

import { Input } from "../../ui/input";
import { EditorContext } from "../../../containers/editor/EditorLayout";

let style = Object.assign({}, global);

const TFont = () => {
  let { metadata, widgets, updateWidgets } = useContext(EditorContext);

  let fonts = JSON.parse(localStorage?.getItem("allFonts"));
  let availableFonts = fonts.filter(font => font.bold_weight !== "");
  let targetWidgetIndex = widgets.findIndex(widget => widget.id === metadata.activeWidgetId[0]);

  const [defaultValue, setDefaultValue] = useState();

  const updateFontFamily = fontFamily => {
    document.querySelector(`#${metadata.activeWidgetId[0]} .timeLine_editor`).style.fontFamily = fontFamily;

    let offSetHeight = document.querySelector(`#${metadata.activeWidgetId[0]} .timeLine_editor`).offsetHeight;
    let mainDivHeight = offSetHeight * (parseFloat(document.getElementById(metadata.activeWidgetId).style.width) / 700); // multyply with scale value: as used at time of insertion- refer to insertion code

    document.querySelector(`#${metadata.activeWidgetId[0]} .dhp-widget-inner`).style.height = `${offSetHeight}px`;

    let tableConfig = document.getElementById(metadata.activeWidgetId).getAttribute("data-table-config");
    tableConfig = JSON.parse(tableConfig);
    let newTableConfig = { ...tableConfig, "font-family": fontFamily };
    let jsonString = JSON.stringify(newTableConfig);
    let widgetObject = widgets[targetWidgetIndex];
    let newArray = Object.assign([...widgets], {
      [targetWidgetIndex]: {
        ...widgetObject,
        style: {
          ...widgetObject.style,
          height: `${mainDivHeight}px`,
        },
        data: {
          ...widgetObject.data,
          "data-table-config": jsonString,
        },
        innerHTML: document.getElementById(metadata.activeWidgetId[0]).innerHTML,
      },
    });
    updateWidgets(newArray);
  };

  // Load current formatting
  useEffect(() => {
    let currentFontFamily = document.querySelector(`#${metadata.activeWidgetId[0]} .timeLine_editor`).style.fontFamily;
    setDefaultValue({ name: currentFontFamily ? currentFontFamily.replace(/^["']|["']$/g, "") : "Open Sans" });
  }, []);

  return (
    <li className={style["toolset-group"]}>
      <div className={cx(style["toolset-item"], style["family-wrap"], style["font-common-action"])}>
        <div className={cx(style["custom-tooltip"])}>
          <Input
            type="dropdown"
            name="family"
            classNamePrefix="select"
            defaultValue={defaultValue}
            getOptionValue={option => option.name}
            getOptionLabel={option => <span style={{ fontFamily: option.name }}>{option.name}</span>}
            options={availableFonts}
            updateState={option => updateFontFamily(option.name)}
            noOptionsMessage={() => "No results found"}
          />
          <div className={cx(style["custom-tooltip-content"], style["top"])}>Font Family</div>
        </div>
      </div>
    </li>
  );
};

export default TFont;
